import script from "./DeactivateAutomationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeactivateAutomationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DeactivateAutomationDialog.vue?vue&type=style&index=0&id=0242dbd7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0242dbd7"]])